import React from "react";
import { useState } from "react";
import Loader from "react-loader-spinner";
import {
  Bar ,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const COLOR = {
  "VC4":"#882DAA",
  "VC5":"#67C2A6",
  "VC10":"#037BE2",
  "VC13":"#5E50A2",
  "VC20":"#C65D18"
}

export default function TransactionTrendChart({loader,data}) {

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload) {
        const payload0 = payload[0];
        const payload1 = payload[1];
        const payload2 = payload[2];
        const payload3 = payload[3];
        const payload4 = payload[4];
        return (
            <div className="line-chart_custom-tooltip">
                <p>Time Slot : {payload0?.payload.axis}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload0?.color }}></span> &nbsp; VC4 : {payload0?.value}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload1?.color }}></span> &nbsp; VC5 : {payload1?.value}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload2?.color }}></span> &nbsp; VC10 : {payload2?.value}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload3?.color }}></span> &nbsp; VC13 : {payload3?.value}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload4?.color }}></span> &nbsp; VC20 : {payload4?.value}</p>
            </div>
        );
    }
    return null;
  };

  
  return (
    <div className="ch-container2">
      <div className="vio_chart npci_chart">
        <p className="block-title" style={{ color: "#131523" }}>
        Time Slot Wise Traffic Analysis
        </p>
        {data.length >0 && Object.keys(COLOR).map((e) => {
          return (
            <>
              <span className="legend-circle-dot" style={{backgroundColor:COLOR[e]}}></span>{e} &nbsp; &nbsp; &nbsp;
            </>
          );
        })}
        <br />
        <br/>
        {
          loader  
          ? <Loader className="loader chart-loader"
           type="ThreeDots"
            color="#9c1d26"
            width={100}
            visible={loader}
            />
         : <>{ data.length > 0 ? (
          <>
            <ResponsiveContainer height={280}>
            <BarChart 
            data={data}
            layout="vertical" barCategoryGap={1}
            barGap={0}            
            >
                <XAxis type="number" height={55}  stroke="0" fontSize={14} label={{ value: "Traffic", dy: 10,stroke: "#B2ACAC", position:"insideBottom"}}/>
                <YAxis
                  type="category"
                  width={70}
                  padding={{ left: 10 }}
                  dataKey="axis"
                  fontSize={14} 
                  label={{ value: "Time slots",  angle: -90, position: "insideLeft", dy: 35, stroke: "#B2ACAC",}} 
                />{" "}
                {<Tooltip content={<CustomTooltip />} />}
                <Bar barSize={8}  dataKey="VC4" fill="#882DAA" />
                <Bar barSize={8}  dataKey="VC5" fill="#67C2A6" />
                <Bar barSize={8}  dataKey="VC10" fill="#037BE2" />
                <Bar barSize={8}  dataKey="VC13" fill="#5E50A2" />
                <Bar barSize={8}  dataKey="VC20" fill="#C65D18" />
              </BarChart>
            </ResponsiveContainer>
          </>
        ) : (
          <p className="no-record-found">Record Not Found</p>
        )}</>}
      </div>
    </div>
  );
}
